import React from 'react'
import { Card, Button, Row, Col } from 'react-bootstrap';
const Videos = () => {

    return (
        <div className="container mt-5">
          <Row>
            <Col md={4}>
              <Card>
                <Card.Img variant="top" src="https://via.placeholder.com/400x300" />
                <Card.Body>
                  <Card.Title>Video 1</Card.Title>
                  <iframe
                    width="100%"
                    height="215"
                    src="https://www.youtube.com/embed/VIDEO_ID_1"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </Card.Body>
              </Card>
            </Col>
    
            <Col md={4}>
              <Card>
                <Card.Img variant="top" src="https://via.placeholder.com/400x300" />
                <Card.Body>
                  <Card.Title>Video 2</Card.Title>
                  <iframe
                    width="100%"
                    height="215"
                    src="https://www.youtube.com/embed/VIDEO_ID_2"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </Card.Body>
              </Card>
            </Col>
    
            <Col md={4}>
              <Card>
                <Card.Img variant="top" src="https://via.placeholder.com/400x300" />
                <Card.Body>
                  <Card.Title>Video 3</Card.Title>
                  <iframe
                    width="100%"
                    height="215"
                    src="https://www.youtube.com/embed/VIDEO_ID_3"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      );
  
}

export default Videos
